module.exports = __webpack_public_path__ + "static/media/night.fc1542e0.jpg";